import { render, staticRenderFns } from "./ClubTournaments.vue?vue&type=template&id=0e6f5f84&scoped=true"
import script from "./ClubTournaments.vue?vue&type=script&lang=js"
export * from "./ClubTournaments.vue?vue&type=script&lang=js"
import style0 from "./ClubTournaments.vue?vue&type=style&index=0&id=0e6f5f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f5f84",
  null
  
)

export default component.exports